import { Box, Skeleton, SxProps } from "@mui/material";
import { ReactElement } from "react";

type SkeletonProps = {
  width: string;
  height?: string;
  animation?: boolean;
  color?: string;
};

type Props = {
  children?: ReactElement;
  loading?: boolean;
  value?: string | boolean | null;
  animation?: false | "pulse" | "wave" | undefined;
  width?: string;
  height?: string;
  color?: string;
  skeletonVariant?: "text" | "rectangular" | "rounded" | "circular" | undefined;
  textAlign?: "left" | "center" | "right";
  rows?: SkeletonProps[];
  sx?: SxProps;
};

const SkeletonWrapper = ({
  loading,
  animation = false,
  value,
  width = "100%",
  height,
  color = "rgba(0, 0, 0, 0.04)", // MUI default color: "rgba(0, 0, 0, 0.11)"
  skeletonVariant = "rectangular",
  children,
  textAlign = "left",
  rows,
  sx,
}: Props) => {
  const showSkeleton = loading || !value;

  const getAlign = () => {
    switch (textAlign) {
      case "center":
        return {
          display: "flex",
          justifyContent: "center",
        };
      case "right":
        return {
          display: "flex",
          justifyContent: "flex-end",
        };
      case "left":
        return {};
    }
  };

  if (showSkeleton && rows) {
    return (
      <>
        {rows.map((item, index) => (
          <Skeleton
            key={index}
            sx={{
              bgcolor: item?.color || color,
              borderRadius: "4px/6.7px",
              margin: "2px 0",
            }}
            width={item.width}
            animation={false}
          />
        ))}
      </>
    );
  }

  return showSkeleton ? (
    <Box sx={{ width: "100%", ...getAlign() }}>
      <Skeleton
        sx={{
          bgcolor: color,
          borderRadius: "4px/6.7px",
          margin: "2px 0",
          ...sx,
        }}
        animation={animation}
        variant={skeletonVariant}
        height={height}
        width={width}
      />
    </Box>
  ) : (
    <>{children}</>
  );
};

export default SkeletonWrapper;
